import { api } from './client';

export interface DoorAccessStatus {
  canAccessOffice: boolean;
  isFired: boolean;
  hasApprovedCredential: boolean;
  isInTrustedNetwork: boolean;
}

export interface DoorAccessLogEntry {
  id: string;
  event: 'token_generated' | 'door_opened' | 'door_failed';
  ipAddress: string | null;
  createdAt: string;
}

export interface DoorCredential {
  id: string;
  deviceName: string | null;
  status: string; // pending | approved | rejected | archived
  createdAt: string;
  approvedAt: string | null;
  archivedAt: string | null;
  archivedReason: string | null;
}

export interface DoorOpenResult {
  url: string;
}

export const doorApi = {
  getStatus: async (): Promise<DoorAccessStatus> => {
    const { data } = await api.get('/door/status');
    return data;
  },

  getCredentials: async (): Promise<DoorCredential[]> => {
    const { data } = await api.get('/door/credentials');
    return data;
  },

  getRegistrationOptions: async (): Promise<any> => {
    const { data } = await api.post('/door/credentials/register-options', {});
    return data;
  },

  registerCredential: async (credential: any, deviceName?: string): Promise<any> => {
    const { data } = await api.post('/door/credentials/register', { credential, deviceName });
    return data;
  },

  archiveCredential: async (id: string): Promise<void> => {
    await api.delete(`/door/credentials/${id}`);
  },

  getAuthenticationOptions: async (): Promise<any> => {
    const { data } = await api.post('/door/authenticate-options', {});
    return data;
  },

  openDoor: async (credential: any): Promise<DoorOpenResult> => {
    const { data } = await api.post('/door/open', { credential });
    return data;
  },

  getMyLog: async (limit = 50): Promise<DoorAccessLogEntry[]> => {
    const { data } = await api.get('/door/my-log', { params: { limit } });
    return data;
  },
};
